// Shared urgency copy and card badge for project boards and task details.
const COPY = {
  en: { field: 'Urgency', all: 'All', levels: ['None', 'Low', 'Medium', 'High', 'Urgent'] },
  uk: { field: 'Терміновість', all: 'Усі', levels: ['Немає', 'Низька', 'Середня', 'Висока', 'Терміново'] },
};
export const URGENCY_VALUES = [0, 1, 2, 3, 4];
export function urgencyCopy(language = 'en') { return COPY[language] || COPY.en; }
export function urgencyValue(value) { return URGENCY_VALUES.includes(value) ? value : 0; }
export function urgencyLabel(value, language) { return urgencyCopy(language).levels[urgencyValue(value)]; }

// Keys are escaped by the caller, using the same escapeHtml as its card markup.
export function renderUrgencyBadge(task, language, escapeHtml) {
  const value = urgencyValue(task.urgency);
  const copy = urgencyCopy(language);
  return `<span class="badge task-urgency-badge urgency-${value}" data-urgency-task="${escapeHtml(task.task_key)}" title="${copy.field}: ${copy.levels[value]}"${value ? '' : ' hidden'}>${copy.levels[value]}</span>`;
}

// A successful drawer save updates every visible copy, including a hover-expanded card.
export function syncUrgencyBadges(task, language, root = document) {
  const value = urgencyValue(task.urgency);
  const copy = urgencyCopy(language);
  for (const badge of root.querySelectorAll('[data-urgency-task]')) {
    if (badge.dataset.urgencyTask !== task.task_key) continue;
    badge.className = `badge task-urgency-badge urgency-${value}`;
    badge.textContent = copy.levels[value];
    badge.title = `${copy.field}: ${copy.levels[value]}`;
    badge.hidden = value === 0;
  }
}
